export default __webpack_public_path__ + "static/media/1426.e408a539.png";